import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import TableQuizez from "./TableQuizez";
import { useLanguage } from "../../../../context/LanguageContext";
import { BaseUrlApi, ErrorMessage } from "../../../../lib/api";
import axios from "axios";
import { toast } from "sonner";
import MainButton from "../../../../components/MainButton";
import { Plus } from "lucide-react";
import { SubLessonData } from "../../../../lib/languages";
import { useNavigate } from "react-router-dom";

export default function TeacherQuizez() {
  const navigate = useNavigate();

  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  const [quizez, setQuizez] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchQuizzes = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/quizzes/teacher`);
      setQuizez(data.data);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") toast("Error", { description: result });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchQuizzes();
  }, []);

  return (
    <div className="space-y-8" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="flex items-center gap-2 justify-between flex-wrap">
        <h1 className="text-2xl font-bold">{t.quizezHeading}</h1>
        <MainButton
          Icon={Plus}
          title={t.addQuiz}
          onClick={() =>
            navigate(`/teacher/add-quiz/teacher`, {
              state: { isTeacher: true },
            })
          }
        />
      </div>
      {!loading ? (
        <TableQuizez data={quizez} fetchQuizzes={fetchQuizzes} />
      ) : (
        <div className="h-40 w-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
}
